import { qa, QAItem, QAType } from "../-data/mock";
import { useEffect, useState } from "react";
import { useNavigate } from "@tanstack/react-router";

"use client"

export default function FAQ(props: { scope: string }) {
    const [loading, setLoading] = useState(true)
    const [data, setData] = useState<any>()
    const navigate = useNavigate()

    useEffect(() => {
        setData(qa[props.scope as keyof QAType])
        setLoading(false)
    }, [props.scope]);

    if (loading) return <span>Loading...</span>

    return (
        <>
            {data.map((item: QAItem) => {
                return (
                    <div
                        key={item.question}
                        className="self-stretch p-3 flex-col justify-start items-start gap-2.5 flex overflow-hidden">
                        <div className="justify-between items-center inline-flex">
                            <div
                                className="text-start text-black text-sm font-medium">{item.question}
                            </div>
                            <div className="w-7 relative origin-top-left -rotate-180">
                                <div className="w-7 left-0 top-0 absolute rounded-full"></div>
                            </div>
                        </div>
                        <div
                            className="self-stretch text-[#979797] text-sm font-medium">{item.answer}
                        </div>
                        {item.nav_link && (<div className="text-[#ffa072] text-sm font-medium" onClick={() => navigate({ href: item.nav_link })}>{item.nav_title}</div>)}
                    </div>
                )
            })}
        </>
    )
}
